const LinkedIn = {
  enable() {},
  wait() {
    return true;
  },
  init() {
    window._tfa = window._tfa || [];
  },
  landing() {},
  paso1() {},
  paso2() {},
  paso3() {},
  paso4() {},
  gracias() {
    window._tfa.push({ notify: "action", name: "conversion" });
    (function() {
      let s = document.getElementsByTagName("script")[0];
      let b = document.createElement("script");
      b.type = "text/javascript";
      b.async = true;
      b.src = "https://cdn.taboola.com/libtrc/frubis-bbva-sc/tfa.js";
      s.parentNode.insertBefore(b, s);
    })();
  },
  mensaje() {}
};

export default LinkedIn;
